import { Transaction } from '../types/Transaction';

type SignedAmountSource = Pick<Transaction, 'displayAmountSigned' | 'amountSigned' | 'kind' | 'type'>;

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const resolveSignedAmountBase = (tx: SignedAmountSource): number | undefined => {
  if (isFiniteNumber(tx.displayAmountSigned)) return tx.displayAmountSigned;
  if (isFiniteNumber(tx.amountSigned)) return tx.amountSigned;
  return undefined;
};

export const getUiSignedAmount = (tx: SignedAmountSource): number | undefined => {
  const baseSigned = resolveSignedAmountBase(tx);
  if (!isFiniteNumber(baseSigned)) return undefined;
  const kindOrType = tx.kind || tx.type;
  if (kindOrType === 'cardPurchase') return -Math.abs(baseSigned);
  return baseSigned;
};
